import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PrimeIcons } from 'primereact/api'
import { Button } from 'primereact/button'

import { MasterDataUploadDialog } from './MasterDataUploadDialog'

export const MasterDataUpload: React.FC = () => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const onClick = (): void => {
    setIsDialogOpen(true)
  }

  const onHide = (): void => {
    setIsDialogOpen(false)
  }

  return (
    <>
      <Button
        onClick={onClick}
        icon={PrimeIcons.UPLOAD}
        label={t('masterDataManagement.suppliers.table.upload.label')}
        outlined
      />
      <MasterDataUploadDialog visible={isDialogOpen} onHide={onHide} />
    </>
  )
}
